// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"bc64d740","787":"955d47e3"}[chunkId] + ".chunk.js";
};